import { set } from 'lodash';
import Axios from "axios";
import constant from "constant/action";

export const BASE_URL = `${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_SERVER_API_PORT ? `:${process.env.REACT_APP_SERVER_API_PORT}` : ''}`;
export const baseURL = `${BASE_URL}/`;

export const axios = Axios.create({
  baseURL,
});

const isInlineAuthErrorHandlingTarget = (url: unknown): boolean => {
  if (typeof url !== "string") {
    return false;
  }
  return url.includes(constant.ADMIN_LOGIN) || url.includes(constant.RANKING_CSV_EXPORT);
};

axios.interceptors.request.use((request) => {
  let token = request.data?.request_type 
    && request.data?.request_type === "secondary" 
    && localStorage.getItem("secondary_token") 
    ? localStorage.getItem("secondary_token") 
    : localStorage.getItem("token");
  if (!token) {
    return request;
  }
  set(request, "headers.Authorization", `Bearer ${token}`);
  return request;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      !isInlineAuthErrorHandlingTarget(error.config?.url)
    ) {
      window.location.href = "/admin/login";
      localStorage.clear();
    }
    return Promise.reject(error);
  }
);

export default axios;
